<template>
	<div class="bigs" style="background: #fff;">
		<navigation></navigation>
		<div class="title-head">请输入交道平台账号与密码</div>
		<div class="pwd">
			<img class="iphones" src="../../../assets/iphone.png" />
			<input type="text" v-model="form.loginName" placeholder="请输入账号或手机号" />
		</div>
		<div class="pwd">
			<img class="pwds" src="../../../assets/pwd.png" />
			<input type="password" v-model="form.pwd" placeholder="密码" />
		</div>
		<div class="mains">
			关于支付：
			<br />
			1、苹果手机用户可通该页面通道支付
			<br />
			2、安卓手机用户可直接通过APP支付
			<br />
			3、未注册，请下载交道APP
			<br />
			4、登录后，请选择学习系统进行缴费
			<br />
		</div>
		<div id="btn" @click="btn">确 &nbsp; 定</div>
		<div id="btns" @click="loginTab">手机号验证码登录</div>
		<div class='loadings' v-if='isShow'>
			<svg t="1631083218420" class="icon svg_icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="5487" width="25" height="25"><path d="M480 96a32 32 0 0 1 64 0v192a32 32 0 0 1-64 0V96z m250.624 60.64a32 32 0 1 1 51.776 37.632L669.568 349.6a32 32 0 0 1-51.808-37.632L730.624 156.64zM897.76 353.024a32 32 0 1 1 19.776 60.864l-182.624 59.328a32 32 0 0 1-19.776-60.864l182.624-59.328z m19.776 257.088a32 32 0 1 1-19.776 60.864l-182.624-59.328a32 32 0 0 1 19.776-60.864l182.624 59.328zM782.4 829.76a32 32 0 0 1-51.776 37.632L617.76 712.064a32 32 0 1 1 51.808-37.632L782.4 829.76zM544 928a32 32 0 0 1-64 0V736a32 32 0 0 1 64 0v192z m-250.624-60.64a32 32 0 0 1-51.776-37.632L354.432 674.4a32 32 0 0 1 51.808 37.632L293.376 867.36zM126.24 670.976a32 32 0 1 1-19.776-60.864l182.624-59.328a32 32 0 0 1 19.776 60.864L126.24 670.976z m-19.776-257.088a32 32 0 0 1 19.776-60.864l182.624 59.328a32 32 0 1 1-19.776 60.864l-182.624-59.328zM241.6 194.24a32 32 0 1 1 51.776-37.632L406.24 311.936a32 32 0 1 1-51.808 37.632L241.6 194.24z" p-id="5488" fill="#ffffff"></path></svg>
			<div>
				登录中...
			</div>
		</div>
	</div>
</template>

<script>
import { Toast, Sidebar, List, SidebarItem, PullRefresh, Overlay, Tab, Tabs, Cell, Loading, Card, Dialog,Notify  } from 'vant';
import navigation from '../../components/nav';
import request from '@/utils/request';
export default {
	components: {
		navigation,
		[Toast.name]: Toast,
		[Sidebar.name]: Sidebar,
		[List.name]: List,
		[SidebarItem.name]: SidebarItem,
		[PullRefresh.name]: PullRefresh,
		[Overlay.name]: Overlay,
		[Tab.name]: Tab,
		[Tabs.name]: Tabs,
		[Cell.name]: Cell,
		[Loading.name]: Loading,
		[Dialog.name]: Dialog,
		[Notify.name]: Notify
	},
	data() {
		return {
			isShow:false,
			form: {
				loginName: '',
				pwd: ''
			}
		};
	},
	created() {

	},
	mounted() {
		let _this = this;
	},

	methods: {
		btn() {
			let _this = this;
			this.isShow = true
			let urls = Global.env + Global.apiCore.logins;
			return new Promise((resolve, reject) => {
				request({
					url: urls,
					method: 'post', //查询一般为get
					data: _this.form //get
				})
					.then(response => {
						if (response.resultCode == '1000') {
							localStorage.setItem('token',response.data.token);
							let url = Global.env + Global.apiCore.Authentication;
							return new Promise((resolve, reject) => {
								request({
									url: url,
									method: 'get', //查询一般为get
								})
									.then(response => {
										// if (response.data.missingType == '0') {
											Notify({ type: 'success', message: '登录成功' });
											this.isShow = false
											setTimeout(function(){
												// window.location.href="https://wx.zpkjedu.com/wechat/authorize?returnUrl=http://m-test.jiaodao11.com/filterSystem"
												window.location.href="https://wx.zpkjedu.com/wechat/authorize?returnUrl=https://m.jiaodao11.com/filterSystem"
											},1000)
										// }
                    // else {
										// 	Dialog.alert({
										// 	message: "请去App或微信小程序认证、核对",
										// 	}).then(() => {
										// 	});
										// 	this.isShow = false
										// }
									})
									.catch(error => {
										this.isShow = false
										Dialog.alert({
											message: error.errmsg
										}).then(() => {
											// on close
										});
										return reject(error);
									});
							});

							// this.$router.push({
							// 	name: 'FilterSystem',
							// 	query: {
							// 	}
							// })
						} else if(response.resultCode == '1001'){
							Dialog.alert({
								message: '请输入正确的账号密码'
							}).then(() => {
								// on close
							});
						}else if(response.resultCode == '1002'){
							Dialog.alert({
								message: '账号格式不正确'
							}).then(() => {
								// on close
							});
						}else if(response.resultCode == '2001'){
							Dialog.alert({
								message: '账号未注册，请登录APP注册账号'
							}).then(() => {
								// on close
							});
						}else if(response.resultCode == '3005'){
							Dialog.alert({
								message: '账号未设置密码，请登录APP设置密码'
							}).then(() => {
								// on close
							});
						}else if(response.resultCode == '3004'){
							Dialog.alert({
								message: '密码输入错误'
							}).then(() => {
								// on close
							});
						}
						this.isShow = false
					})
					.catch(error => {
						Dialog.alert({
							message: error.errmsg
						}).then(() => {
							// on close
						});
						return reject(error);
					});
			});

			// localStorage.setItem('token', JSON.stringify(_this.form));
			// localStorage.getItem(name);
			// localStorage.removeItem(name);
		},
		loginTab() {
			this.$router.push({
				name: 'PhoneLogin',
				query: {
				}
			});
		}
	}
};
</script>

<style>
.title-head {
	font-size: 0.36rem;
	font-weight: 400;
	color: rgba(51, 51, 51, 1);
	margin: 0 auto;
	margin-top: 0.62rem;
	margin-bottom: 0.8rem;
	text-align: center;
}
.pwd {
	width: 75%;
	height: 1.06rem;
	overflow: hidden;
	border-bottom: 1px solid rgba(242, 242, 242, 1);
	margin: 0 auto;
	position: relative;
}
.pwds {
	width: 0.28rem;
	height: 0.34rem;
	position: absolute;
	left: 0.2rem;
	top: 0.34rem;
}
.iphones {
	width: 0.3rem;
	height: 0.36rem;
	position: absolute;
	left: 0.2rem;
	top: 0.34rem;
}
.pwd input {
	width: 4rem;
	line-height: 1.04rem;
	border: none;
	font-size: 0.3rem;
	font-weight: 400;
	color: rgba(195, 195, 195, 1);
	position: absolute;
	left: 0.8rem;
	top: 0;
}
.mains {
	width: 75%;
	margin: 0 auto;
	margin-top: 0.7rem;
	line-height: 0.5rem;
	font-size: 0.3rem;
	font-weight: 400;
	color: rgba(246, 60, 69, 1);
}
#btn {
	width: 75%;
	height: 0.82rem;
	line-height: 0.82rem;
	background: #f63c45;
	border-radius: 4px;
	margin: 0 auto;
	margin-top: 2rem;
	text-align: center;
	font-weight: 400;
	color: rgba(255, 255, 255, 1);
	font-size: 0.34rem;
}
#btns{
	width: 75%;
	height: 0.82rem;
	line-height: 0.82rem;
	border-radius: 4px;
	margin: 0 auto;
	margin-top: 0.2rem;
	text-align: center;
	font-weight: 400;
	color: #007bff;
	font-size: 0.34rem;
	margin-bottom: 1rem;
}

.van-button--large {
	line-height: 0 !important;
	font-size: 0.32rem !important;
}
.loadings{
		display: flex;
		align-items: center;
		justify-content: center;
		height: 2rem;
		width: 2.5rem;
		text-align: center;
		line-height: 2rem;
		border-radius: 0.4rem;
		background: rgba(0, 0, 0, 0.6);
		position: absolute;
		left: 0;
		right: 0;
		top: 25%;
		color: #fff;
		margin: auto;
		font-size: 0.32rem;
}
.svg_icon{
	  animation:turn 1.5s linear infinite;
	  margin-right: 0.2rem;
}
@keyframes turn{
      0%{-webkit-transform:rotate(0deg);}
      25%{-webkit-transform:rotate(90deg);}
      50%{-webkit-transform:rotate(180deg);}
      75%{-webkit-transform:rotate(270deg);}
      100%{-webkit-transform:rotate(360deg);}
    }
</style>
